import { render, staticRenderFns } from "./VehicleReportDetail.vue?vue&type=template&id=67021a16&scoped=true&"
import script from "./VehicleReportDetail.vue?vue&type=script&lang=js&"
export * from "./VehicleReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./VehicleReportDetail.vue?vue&type=style&index=0&id=67021a16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67021a16",
  null
  
)

export default component.exports